// extracted by mini-css-extract-plugin
export default {"infoTooltipInfo":"styles_infoTooltipInfo__sIox4","tooltipIcon":"styles_tooltipIcon__aR1iF","InfoTooltip":"styles_InfoTooltip__xbcQO"};